import { ListItem } from '@microsoft/microsoft-graph-types';
import { Observable } from 'rxjs';

export interface Change {
  ListItem$: Observable<ListItem>;
  SiteTitle: string;
  TimeAsDate: Date;
  UserPhoto$: Observable<any>;
  ItemUrl: string;
  SiteUrl: string;
  Title: string;
  ChangeType: ChangeType;
  Editor: string;
  EditorEmailHint: string;
  ItemId: number;
  ListId: string;
  ServerRelativeUrl: string;
  SharedByUser: any;
  SharedWithUsers: any;
  SiteId: string;
  Time: string;
  UniqueId: string;
  WebId: string;
}

export enum ChangeType {
  NoChange = 0,
  Add = 1,
  Update = 2,
  DeleteObject = 3,
  Rename = 4,
  MoveAway = 5,
  MoveInto = 6,
  Restore = 7,
  RoleAdd = 8,
  RoleDelete = 9,
  RoleUpdate = 10,
  AssignmentAdd = 11,
  AssignmentDelete = 12,
  MemberAdd = 13,
  MemberDelete = 14,
  SystemUpdate = 15,
  Navigation = 16,
  ScopeAdd = 17,
  ScopeDelete = 18,
  ListContentTypeAdd = 19,
  ListContentTypeDelete = 20,
  Dirty = 21,
  Activity = 22
}
